import memoize from 'lodash/memoize';
import { createSelector } from 'reselect';

import { getSubjects } from 'store/courses/selectors';
import { CourseSubject } from 'store/courses/typings';
import { getSubjectFromProps } from 'utils/selectors/selectors';

interface PropsWithNavSubject {
    navSubject: string | null;
}

type navSubjectFromPropsMemoizeFnType = <T extends PropsWithNavSubject>(_storeState: any, ownProps: T) => string | null;
const navSubjectFromPropsMemoizeFn: navSubjectFromPropsMemoizeFnType = (_storeState, ownProps) => ownProps.navSubject;
export const getNavSubjectFromProps: navSubjectFromPropsMemoizeFnType = memoize(
    navSubjectFromPropsMemoizeFn,
    navSubjectFromPropsMemoizeFn
);

export const getCourseSubject = createSelector(
    [getSubjects, getSubjectFromProps],
    (subjects, subject): CourseSubject | null => {
        return subjects.find((courseSubject) => courseSubject.subject === subject) || null;
    }
);
